// src/utils/analytics.ts

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const Analytics = {
  // Track page views
  pageview: (url: string, title: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-CEMH7P45LZ', {
        page_title: title,
        page_location: url,
      });
    }
  },

  // Track events
  event: (action: string, category: string, label?: string, value?: number) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    }
  },

  // Specific tracking methods for your site
  trackArticleView: (articleId: string, articleTitle: string) => {
    Analytics.event('view_article', 'Articles', `${articleId}: ${articleTitle}`);
  },

  trackArticleRead: (articleId: string, articleTitle: string, readTime: number) => {
    Analytics.event('read_article', 'Articles', `${articleId}: ${articleTitle}`, readTime);
  },

  trackFatwaView: (fatwaId: string, fatwaTitle: string) => {
    Analytics.event('view_fatwa', 'Fatwas', `${fatwaId}: ${fatwaTitle}`);
  },

  trackInvocationDownload: (invocationId: string, invocationTitle: string) => {
    Analytics.event('download_invocation', 'Invocations', `${invocationId}: ${invocationTitle}`);
  },

  trackSearch: (query: string, category: string, resultsCount: number) => {
    Analytics.event('search', 'Search', `${category}: ${query}`, resultsCount);
  },

  trackPageVisit: (pageName: string) => {
    Analytics.event('page_visit', 'Navigation', pageName);
  },

  trackCategoryFilter: (category: string, type: 'Articles' | 'Fatwas') => {
    Analytics.event('filter_category', 'Filters', `${type}: ${category}`);
  },

  trackTagFilter: (tag: string, type: 'Articles' | 'Fatwas') => {
    Analytics.event('filter_tag', 'Filters', `${type}: ${tag}`);
  }
};
